// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__2Ilmg","time":"styles_time__3XYBE"};